import styled from "styled-components";

export const GridGroup3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
`;

export const InputFile = styled.label`
  width: 100%;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  border: none;
  &:focus {
    outline: none;
    border: none;
  }
`;

export const InputNumberFormatWrapper = styled.div`
  input {
    width: 100%;
    font-size: 16px;
    font-weight: 300;
    line-height: 19px;
    /* margin-bottom: 5px; */
    height: 40px;
    border: none;
    color: black;
    padding: 10px;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      color: red;
    }
  }
`;
